import {
  CoinPriceTextFormat,
  CustomerName,
  PaymentHistoryState,
  PaymentHistoryStatus,
  ProviderName,
} from "@lib/components/MiniComponents/Others";
import { StyledDescriptionLabel } from "@app/Monitoring/AuditLogs/Detail/index.styled";
import { StyledTransactionDetailDescriptions } from "@lib/components/PageComponents/Transaction/TransactionDetailModal/index.styled";
import { AuthRoles, TransactionType } from "@lib/types";
import { Descriptions, Tag, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import useScreen from "@lib/hooks/useScreen";
import dayjs from "dayjs";
import { useTypedSelector } from "@lib/redux";
import { red } from "@ant-design/colors";

type Props = {
  transaction?: TransactionType;
};

export default function TransactionDetails({ transaction }: Props) {
  const { user } = useTypedSelector((state) => state.auth);
  const role = user?.role;
  // const { messages } = useIntl();
  const { isMobile } = useScreen();

  if (!transaction) return null;

  return (
    <StyledTransactionDetailDescriptions bordered column={isMobile ? 1 : 2}>
      {role === AuthRoles.Admin && (
        <Descriptions.Item
          label={
            <StyledDescriptionLabel>
              <FormattedMessage id="common.provider" />
            </StyledDescriptionLabel>
          }
        >
          {transaction?.provider ? (
            <ProviderName provider={transaction?.provider} />
          ) : (
            <Tag color={red[7]}>
              <FormattedMessage id="common.noProvider" />
            </Tag>
          )}
        </Descriptions.Item>
      )}

      {role === AuthRoles.Admin && (
        <Descriptions.Item
          label={
            <StyledDescriptionLabel>
              <FormattedMessage id="common.customer" />
            </StyledDescriptionLabel>
          }
        >
          <CustomerName customer={transaction?.customer} />
        </Descriptions.Item>
      )}

      <Descriptions.Item
        label={
          <StyledDescriptionLabel>
            <FormattedMessage id="common.requestId" />
          </StyledDescriptionLabel>
        }
      >
        <Typography.Text copyable={{ text: transaction?.externalId }}>
          {transaction?.externalId}
        </Typography.Text>
      </Descriptions.Item>
      <Descriptions.Item
        label={
          <StyledDescriptionLabel>
            <FormattedMessage id="common.amount" />
          </StyledDescriptionLabel>
        }
      >
        <CoinPriceTextFormat
          amount={transaction?.amount || 0}
          showCurrency={transaction?.currency}
          showCurrencyImage
          align="left"
        />
      </Descriptions.Item>

      <Descriptions.Item
        label={
          <StyledDescriptionLabel>
            <FormattedMessage id="common.updatedAt" />
          </StyledDescriptionLabel>
        }
      >
        <Typography.Text>
          {dayjs(transaction?.updatedAt).format("DD/MM/YYYY HH:mm")}
        </Typography.Text>
      </Descriptions.Item>

      <Descriptions.Item
        label={
          <StyledDescriptionLabel>
            <FormattedMessage id="common.status" />
          </StyledDescriptionLabel>
        }
      >
        <PaymentHistoryStatus status={transaction?.status} />
      </Descriptions.Item>

      <Descriptions.Item
        label={
          <StyledDescriptionLabel>
            <FormattedMessage id="common.state" />
          </StyledDescriptionLabel>
        }
      >
        <PaymentHistoryState state={transaction?.state} shorten />
      </Descriptions.Item>
    </StyledTransactionDetailDescriptions>
  );
}
